import React from 'react';
import { HeadphonesIcon, BookOpenIcon, WalletIcon, HeartPulseIcon, UsersIcon, ShieldIcon, GraduationCapIcon, MessageCircleIcon } from 'lucide-react';
export function IncludedSection() {
  return <section id="incluye" className="py-20 bg-gradient-to-b from-purple-50 to-white" data-id="element-179">
      <div className="container mx-auto px-4" data-id="element-180">
        <div className="max-w-4xl mx-auto" data-id="element-181">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-16 text-purple-800" data-id="element-182">
            Lo Que Recibirás
          </h2>
          <div className="grid md:grid-cols-2 gap-6" data-id="element-183">
            <div className="bg-white p-6 rounded-xl shadow-sm flex" data-id="element-184">
              <div className="mr-4 text-purple-600" data-id="element-185">
                <HeadphonesIcon size={24} data-id="element-186" />
              </div>
              <div data-id="element-187">
                <h3 className="font-semibold text-lg mb-1 text-purple-800" data-id="element-188">
                  Meditaciones con frecuencias binaurales
                </h3>
                <p className="text-gray-600" data-id="element-189">
                  Método CIA para reprogramación profunda.
                </p>
              </div>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm flex" data-id="element-190">
              <div className="mr-4 text-purple-600" data-id="element-191">
                <BookOpenIcon size={24} data-id="element-192" />
              </div>
              <div data-id="element-193">
                <h3 className="font-semibold text-lg mb-1 text-purple-800" data-id="element-194">
                  Manual completo
                </h3>
                <p className="text-gray-600" data-id="element-195">
                  Con protocolos y técnicas detalladas.
                </p>
              </div>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm flex" data-id="element-196">
              <div className="mr-4 text-purple-600" data-id="element-197">
                <WalletIcon size={24} data-id="element-198" />
              </div>
              <div data-id="element-199">
                <h3 className="font-semibold text-lg mb-1 text-purple-800" data-id="element-200">
                  Audios específicos para Abundancia
                </h3>
                <p className="text-gray-600" data-id="element-201">
                  Reprograma tu relación con la prosperidad.
                </p>
              </div>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm flex" data-id="element-202">
              <div className="mr-4 text-purple-600" data-id="element-203">
                <HeartPulseIcon size={24} data-id="element-204" />
              </div>
              <div data-id="element-205">
                <h3 className="font-semibold text-lg mb-1 text-purple-800" data-id="element-206">
                  Audios específicos para Salud
                </h3>
                <p className="text-gray-600" data-id="element-207">Activa la sanación interior.</p>
              </div>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm flex" data-id="element-208">
              <div className="mr-4 text-purple-600" data-id="element-209">
                <UsersIcon size={24} data-id="element-210" />
              </div>
              <div data-id="element-211">
                <h3 className="font-semibold text-lg mb-1 text-purple-800" data-id="element-212">
                  Audios específicos para Relaciones
                </h3>
                <p className="text-gray-600" data-id="element-213">
                  Transforma tus conexiones personales.
                </p>
              </div>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm flex" data-id="element-214">
              <div className="mr-4 text-purple-600" data-id="element-215">
                <ShieldIcon size={24} data-id="element-216" />
              </div>
              <div data-id="element-217">
                <h3 className="font-semibold text-lg mb-1 text-purple-800" data-id="element-218">
                  BONO: Frecuencia Diamante
                </h3>
                <p className="text-gray-600" data-id="element-219">
                  Para protección energética completa.
                </p>
              </div>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm flex" data-id="element-220">
              <div className="mr-4 text-purple-600" data-id="element-221">
                <GraduationCapIcon size={24} data-id="element-222" />
              </div>
              <div data-id="element-223">
                <h3 className="font-semibold text-lg mb-1 text-purple-800" data-id="element-224">
                  4 Masterclasses
                </h3>
                <p className="text-gray-600" data-id="element-225">De Control Mental Avanzado.</p>
              </div>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm flex" data-id="element-226">
              <div className="mr-4 text-purple-600" data-id="element-227">
                <MessageCircleIcon size={24} data-id="element-228" />
              </div>
              <div data-id="element-229">
                <h3 className="font-semibold text-lg mb-1 text-purple-800" data-id="element-230">
                  Acceso a la Comunidad Secreta
                </h3>
                <p className="text-gray-600" data-id="element-231">
                  Para acompañamiento y apoyo continuo.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}